document.addEventListener("DOMContentLoaded", () => {
  const link = document.getElementById("eco-sds-link");
  const data = document.getElementById("eco-sds-data");
  if (!link || !data) return;

  const base   = data.getAttribute("data-base");
  const cid    = data.getAttribute("data-cid");
  const lang   = data.getAttribute("data-lang") || "2";
  const market = data.getAttribute("data-market") || "2";
  const fallbackSku = data.getAttribute("data-fallback-sku") || "";

  // variantMap = "variantId:SKU,variantId:SKU,..."
  const variantMap = {};
  (data.getAttribute("data-variant-map") || "")
    .split(",")
    .forEach(pair => {
      const [id, sku] = pair.split(":");
      if (id) variantMap[id] = (sku || "").trim();
    });

  function buildUrl(sku) {
    const p = new URL(base);
    p.searchParams.set("msdsCid", cid);
    p.searchParams.set("viewForm", "pdf");
    p.searchParams.set("msdsEr", sku || fallbackSku || "");
    p.searchParams.set("msdsLang", lang);
    p.searchParams.set("msdsMarket", market);
    return p.toString();
  }

  function updateByVariantId(variantId) {
    const sku = variantMap[String(variantId)] || fallbackSku;
    if (!sku) {
      link.style.display = "none";
      return;
    }
    link.href = buildUrl(sku);
    link.style.display = "";
  }

  // 1) Teman skickar ofta ett event med detail.variant (Remix/Dawn m.fl.)
  document.addEventListener("variant:change", (e) => {
    const v = e.detail && (e.detail.variant || e.detail);
    if (v && v.id) updateByVariantId(v.id);
  });
  document.addEventListener("product:variant-change", (e) => {
    const v = e.detail && (e.detail.variant || e.detail);
    if (v && v.id) updateByVariantId(v.id);
  });

  // 2) Fallback: observera <input name="id"> (variant-id)
  const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (idInput) {
    let prev = idInput.value;
    const obs = new MutationObserver(() => {
      if (idInput.value !== prev) {
        prev = idInput.value;
        updateByVariantId(idInput.value);
      }
    });
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Init – försäkra startlänk
  const initialVariantId = (idInput && idInput.value) || Object.keys(variantMap)[0];
  if (initialVariantId) updateByVariantId(initialVariantId);
});

// Tips: lägg till scriptet på produktsidor
// {{ 'eco-shoplink.js' | asset_url | script_tag }}
